import styled from '@emotion/styled';
import HistoryIcon from '@mui/icons-material/History';
import LayersIcon from '@mui/icons-material/Layers';
import SubjectIcon from '@mui/icons-material/Subject';
import TocIcon from '@mui/icons-material/Toc';
import React, { SetStateAction } from 'react';
import { useParams } from 'react-router-dom';

import * as GQL from '~/graphql/generated/client';
import { Policy } from '~/graphql/generated/server';
import { LeftNavMenu, LeftNavMenuItem } from '~c/components/base/left-nav';
import {
  dashboardRouteUtil,
  policyDetailsRoutesUtil,
  policyVersionsRoutesUtil,
} from '~c/routes';

interface Props {
  className?: string;
}

const PreviousPoliciesImp: React.FC<Props> = ({ className }) => {
  const back = policyDetailsRoutesUtil.useHelper();
  const { versionId } = useParams();
  const { navigateTo } = policyVersionsRoutesUtil.useHelper();
  const { policyId } = useParams();
  const { data } = GQL.usePreviousPoliciesFromIdQuery({
    variables: { id: policyId! },
    skip: !policyId,
  });

  const previousVersions = data?.previousPoliciesFromId?.previousVersions;

  const handleVersionClick = (policy: Policy, id: number) => {
    navigateTo('CONTROL_BUNDLES', {
      params: { versionId: policy._id },
    });
  };

  return (
    <LeftNavMenu
      className={className}
      name={policyVersionsRoutesUtil.routePrefix}
      header={{ onClick: () => back.navigateTo('PREVIOUS_VERSIONS') }}
    >
      {previousVersions?.map((policy, id) => {
        return (
          <div key={policy._id}>
            <LeftNavMenuItem
              icon={LayersIcon}
              selected={versionId === policy._id}
              onClick={() => handleVersionClick(policy as Policy, id)}
            >
              {policy.version}
            </LeftNavMenuItem>
          </div>
        );
      })}
    </LeftNavMenu>
  );
};

const PreviousPoliciesNav = styled(PreviousPoliciesImp)`
  .grow {
    flex-grow: 1;
  }
`;

export default PreviousPoliciesNav;
